import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { TextField, IconButton, Chip, Avatar} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Search } from "@material-ui/icons";
import {getLabels} from '../constants/labels';


const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    borderRadius: '50px',
  },
  autocomplete: {
    borderRadius:"50px",
    width:"100%",
    maxHeight:'54px',
    overflow:'auto',
    border:'2px solid #eeeeee',
    '&:hover': {
      border: '2px solid #c1c6c9'
    },
    backgroundColor:"white",
    '& .MuiChip-root': {
      margin: theme.spacing(0.5),
      backgroundColor:'#d4e2e9',
      color:"black",
      height:'28px'
    },
  },
  searchButton: {
    height: 45,
    width:45,
    paddingLeft: 5,
    paddingTop: 12,
    marginTop: 5,
    marginLeft: 5
  },
  tag: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 300,
  },
  avatar: {
    backgroundColor: "#384257",
    borderColor: `1px solid #384257`,
    color: "#ffffff",
    width: 30,
    height: 30,
    marginBottom: 6
  },
  input: {
    width: '100%',
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: '50px',
      borderWidth: "1px",
      borderColor: "white !important"
    },
    backgroundColor:"white",
    borderRadius:'50px',
    overflow:"hidden",
  }
}));

/** The following component describes the search bar along with its functionalities */

export default function Searcher({ onApplySearch, loadAutocomplete, onTagRemove,
  tags, setTag, input_value, onInputChange, options, option_label, language, signed_user
}) {
  const classes = useStyles();
  const labels = getLabels(language);
  const handleKeyDown = event => {
    switch (event.key) {
      case " ": {
        event.preventDefault();
        event.stopPropagation();
        if (event.target.value.length > 0) {
          setTag(tags, event.target.value);
        }
        break;
      }
      case "Enter": {
        event.preventDefault();
        event.stopPropagation();
        onApplySearch(tags);
        (document.getElementById("tags-outlined")).blur(); // Unfocuses searcher input element
        break;
      }
      default:
    }
  };

  return (
    <div className={classes.root}>
      <Autocomplete
        filterSelectedOptions
        multiple
        freeSolo
        id="tags-outlined"
        options={options}
        getOptionLabel={option => option[option_label]}
        value={tags}
        renderTags={(values) =>
          values.map((value) => {
            return <Chip
                      key={value}
                      label={value[option_label]}
                      style={{maxWidth: 230 }}
                      onDelete={() => {
                onTagRemove(value);
              }}
            />
          })
        }
        className={classes.autocomplete}
        classes={{tag: classes.tag}}
        onChange={(event, newValue) => setTag(newValue)}
        renderInput={(params) => {
          params.inputProps.onKeyDown = handleKeyDown;
          return (
            <TextField
              {...params}
              className={classes.input}
              variant="outlined"
              placeholder={
                signed_user ?
                labels.search_placeholder :
                labels.public_search_placeholder
              }
              fullWidth
              inputProps={{ ...params.inputProps, style: { fontSize: 14 }}}
              value={input_value}
              onChange={(event) => {
                loadAutocomplete(event.target.value);
                onInputChange(event.target.value);
              }}
            />
          );
        }}
      />
      <IconButton
          color="primary"
          className={classes.searchButton}
          onClick={() => onApplySearch(tags)}
      >
        <Avatar className={classes.avatar}>
          <Search/>
        </Avatar>
      </IconButton>
    </div>
  );
}
